import validate from "/opt/build/repo/node_modules/.pnpm/nuxt@3.12.2_@opentelemetry+api@1.9.0_eslint@9.5.0_rollup@2.79.1_typescript@5.5.2_vite@5.3.1_vue-tsc@2.0.22/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/build/repo/node_modules/.pnpm/nuxt@3.12.2_@opentelemetry+api@1.9.0_eslint@9.5.0_rollup@2.79.1_typescript@5.5.2_vite@5.3.1_vue-tsc@2.0.22/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}